var sources         = JSON.parse('{"core":{"fileName":"libraries/core.js","build":1476834407300},"template":{"fileName":"libraries/template.js","build":1476978458444}}'),
  win               = window,
  message           = win.addEventListener ? 'message' : 'onmessage',
  attachListener    = win.addEventListener ? 'addEventListener' : 'attachEvent',
  parentWin         = win.parent,
  ls                = {setItem : function(){}, getItem : function(){} },
  objProto          = Object.prototype,
  headElm           = win.document.head || win.document.getElementsByTagName( 'head' )[ 0 ] || win.document.documentElement,
  script            = win.document.getElementsByTagName( 'script' )[ 0 ],
  scriptSrc         = win.document.location.href,
  baseURL           = scriptSrc.match( /(.*)(?:\/a1_webtag)/ )[ 1 ] + '/',
  lsKey             = 'A1C',
  config            = {},
  i, k;

try{
  ls = win.localStorage;
} catch (e) {}
// Basic getType method for a smaller footprint
function getType(val) {
  return val === null ? '[Object Null]' : val === undefined ? '[Object Undefined]' : objProto.toString.call( val );
}

function getLibraryKey( library ) {
  return lsKey + ':' + library + ':' + ( win.build || sources[ library ] ? sources[ library ].build : 0 );
}

function toQS( data ) {
  var ret = '';
  if ( getType(data) === getType({}) ) {
    ret = Object.keys( data ).map(function ( key ) {
      if ( data[key] !== null ) {
        return encodeURIComponent( key ) + '=' + encodeURIComponent( data[ key ] );
      }
    }).join( '&' );
  }
  return ret;
}

function executeCode( code, library ) {
  var postCode = code;

  if ( library ) {
    postCode = {
      type: 'library',
      id: library,
      data: code
    };
  }

  parentWin.postMessage( JSON.stringify( postCode ), '*' );

  if( library && !ls.getItem( getLibraryKey( library ) ) ) {
    try{
      ls.setItem( getLibraryKey( library ), code );
    } catch(e) {
      // no-op
    }
  }
}

function getLibrary( library ) {
  var code = ls.getItem( getLibraryKey( library ) );
  // eval code if already stored
  if ( code ) {
    if ( DEBUG ) {
      console.log( (+new Date()) + ' Library pulled from storage: ' + library );
    }
    executeCode( code, library );
  // otherwise load the new library that was requested
  } else if ( sources[ library ] ) {
    if ( DEBUG ) {
      console.log( (+new Date()) + ' Loading: ', 'GET', baseURL + sources[ library ].fileName + '?_=' + (+new Date()) );
    }
    var script = win.document.createElement( 'script' );
    script.src = baseURL + sources[ library ].fileName + '?_=' + (+new Date());   
    headElm.appendChild( script );
  }
}

function getData( request ) {
  var xmlhttp = new win.XMLHttpRequest();

  function execute( result ) {
    executeCode({
      type: 'data',
      id: request.id,
      data: result
    });
  }
  function handler() {
    var response;
    if ( xmlhttp.readyState === 4 ) {
      try {
        response = xmlhttp.responseText ? JSON.parse( xmlhttp.responseText ) : {};
        if ( xmlhttp.status >= 200 && xmlhttp.status < 300 ) {
          execute( response );
        } else if ( response.userMessage ) {
          execute( { code: response.errorCode || xmlhttp.status, error: response.userMessage } );
        } else {
          execute( { code: xmlhttp.status || 500, error: xmlhttp.statusText || 'Unknown Server Error' } );
        }
      } catch( err ) {
        execute( { error: 'Invalid JSON Response' } );
      }
    }
  }

  if ( getType( request ) !== getType({}) ) {
    execute( { error: 'getData: "request" object is required' } );
  } else if ( getType( request.url ) !== getType('') ) {
    execute( { error: 'getData: "request.url" must be a string' } );
  } else {
    request.method = request.method || 'GET';

    if ( request.allowCache !== true && request.method === 'GET' ) {
      request.url = request.url + ( request.url.indexOf('?') > -1 ? '&' : '?' ) + '_=' + (+new Date());
    }
    xmlhttp.onreadystatechange = handler;
    xmlhttp.open( request.method, request.url );
    if ( DEBUG ) {
      // console.log( (+new Date()) + ' Loading: ', request.method, JSON.stringify( request.headers ), request.url, JSON.stringify( request.data ) );
      console.log( (+new Date()) + ' Loading: ', request.method, request.url, JSON.stringify( request.data ) );
    }
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.send( JSON.stringify( request.data ) );
  }
  return xmlhttp;
}

config.key = null;
// Each parameter becomes a global variable
scriptSrc.replace( /[?&]+([^=&]+)=([^&]*)/gi, function( pattern, key, val ) {
  config[ key ] = decodeURIComponent( val );
  if ( config[ key ].indexOf( ',' ) > -1 ) {
    config[ key ] = config[ key ].split( ',' );
  }
  config[ key ] = config[ key ] === 'false' ? false : config[ key ] === 'true' ? true : config[ key ];
});

if (ls.length && ls.key) {
  // Clean-up old releases
  i = ls.length;
  while ( i-- ) {
    k = ls.key( i );
    if ( k.split(':')[0] === lsKey && k !== getLibraryKey( k.split( ':' )[ 1 ] ) ) {
      ls.removeItem( k );
    }
  }
}

// Message event listener for when the parent window requests additional libraries after the initial library load
win[ attachListener ]( message, function( event ) {
  var message;
  try {
    message = JSON.parse(event.data);
  } catch (e) {}
  if (message && (event.source === parentWin) && (getType(message) === getType({})) && message.type) {
    switch ( message.type ) {
    case 'library':
      getLibrary( message.data );
      break;
    case 'data':
      getData( message.data );
      break;
    case 'config':
      if ( DEBUG ) {
        console.log( (+new Date()) + ' Loader Config: Set ' + message.data.key + ' = ' + message.data.value );
      }
      config[ message.data.key ] = message.data.value;
      break;
    default:
      try {
        win.console.error( 'AgilOne WebTag - Unrecognized message type: ' + message.type );
      } catch( err ) {
        // no-op
      }
    }
  }
}, false );

getLibrary( 'core' );

// Load any libraries that were requested while loader was in progress
executeCode({
  type: 'function',
  id: 'core_complete',
  data: '(function(){var lib;while(lib=neededLibraries.pop()){requestLibrary(lib);}loaderFinished=true;})();'
});
